import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { Icon } from '../../icon/icon';
import styles from './placeholder.css';

const Placeholder = ({ animate }) => (
    <SimpleFlexbox className={classNames({ [styles.shake]: animate }, styles.base)} margin="all_xsmall" position="relative">
        <SimpleFlexbox className={styles.container} bgColor="brand_primary_60">
            <SimpleFlexbox className={styles.base} column>
                <div className={styles.icon}>
                    <Icon
                        UIComponent="icon_brand_base_0_semi_rounded"
                        variant="ctm_skinny_tick"
                        size="large" />
                </div>
                <div className={styles.text}>
                    Select a product above to compare
                </div>
            </SimpleFlexbox>
        </SimpleFlexbox>
    </SimpleFlexbox>
);

Placeholder.propTypes = {
    animate: PropTypes.bool
};

export { Placeholder };
